import React, { FC } from 'react';
import classNames from 'classnames';
import { SystemButtonContent } from '../SystemButton';
import styles from './brand_button.module.scss';
import { Hyperlink } from '../../Hyperlink';
import { SystemButtonHyperlinkProps } from '../button.types';
import { SystemHyperlinkDefault } from '../systemButtonDefaultProps';

type Props = {
  large?: boolean;
  expanded?: boolean;
  iconLeft?: string;
  iconRight?: string;
} & SystemButtonHyperlinkProps;

export const BrandHyperlink: FC<Props> = ({
  large,
  expanded,
  iconLeft,
  iconRight,
  target,
  href,
  rel,
  source,
  onClick,
  children,
  ...props
}) => {
  return (
    <Hyperlink
      className={classNames(styles.brand, {
        [styles.large]: large,
        [styles.small]: !large,
        [styles.expanded]: expanded,
      })}
      target={target}
      href={href}
      rel={rel}
      source={source}
      onClick={onClick}
      {...props}
    >
      <SystemButtonContent iconLeft={iconLeft} iconRight={iconRight}>
        {children}
      </SystemButtonContent>
    </Hyperlink>
  );
};

BrandHyperlink.defaultProps = {
  large: false,
  expanded: false,
  iconLeft: '',
  iconRight: '',
  ...SystemHyperlinkDefault,
};
